import { mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters('Auth', ['user']),
		userOnboardingDashboard() {
			return this.user['onboarding-dashboard']
		},
		showOnboardingDashboard() {
			return this.userOnboardingDashboard?.status === this.$constants.GENERIC_STATUS.ACTIVE
		},
		getReferralTemplate() {
			if (this.forceReferralPreOnboarding) {
				return this.forceReferralPreOnboarding
			}
			return this.user.use_referral_template_dashboard
		},
		isReferralPreOnboardingDone() {
			return this.user.tags.onboarding_referral_use_template || this.user.tags.onboarding_referral_start_from_scratch
		},
		forceReferralPreOnboarding() {
			const referralPreOnboarding = this.$route.query.referralPreOnboarding
			const template = Object.values(this.$constants.REFERRAL_DASHBOARD_TEMPLATE_NAMES).includes(referralPreOnboarding)
			return template ? referralPreOnboarding : null
		},
		showReferralPreOnboardingDashboard() {
			if (this.forceReferralPreOnboarding) {
				return true
			}
			return !this.isReferralPreOnboardingDone && this.getReferralTemplate
		},
	},
}
